import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6537">
      <div data-id="element-6538">
        <div className="text-sm font-medium text-slate-900" data-id="element-6539">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-6540">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-6541">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6542" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-6543">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6544">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6545">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-6546" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6547">
          <Input label="Название платформы" defaultValue="Astriqo" data-id="element-6548" />
          <Input label="Основной домен" defaultValue="astriqo.com" data-id="element-6549" />
          <Input label="Email поддержки" defaultValue="support@astriqo.com" data-id="element-6550" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-6551" />
          <div className="md:col-span-2" data-id="element-6552">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6553">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6554">
              <option value="ru" data-id="element-6555">Русский (RU)</option>
              <option value="en" data-id="element-6556">English (EN)</option>
              <option value="es" data-id="element-6557">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6558">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6559">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-6560" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6561">
          <div data-id="element-6562">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6563">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6564">
              <option value="RUB" data-id="element-6565">Российский рубль (₽)</option>
              <option value="USD" data-id="element-6566">Доллар США ($)</option>
              <option value="EUR" data-id="element-6567">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-6568">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6569">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6570">
              <option value="Europe/Moscow" data-id="element-6571">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-6572">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-6573">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6575" />} onClick={handleSave} data-id="element-6574">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-6576">
      <div className="flex justify-between items-center" data-id="element-6577">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-6578">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6580" />} data-id="element-6579">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6581">
        <table className="w-full text-left" data-id="element-6582">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6583">
            <tr data-id="element-6584">
              <th className="px-4 py-3 font-medium" data-id="element-6585">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-6586">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-6587">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-6588">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-6589">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-6590">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-6591">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6592">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6593">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-6594">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-6595">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6596">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6597">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-6598">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-6599">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-6600">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-6601">
                  <div className="flex justify-end gap-2" data-id="element-6602">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-6604" />} data-id="element-6603" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-6606" />} data-id="element-6605" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-6607">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6608">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6609">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6610">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-6611" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-6612">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6613">
                <div data-id="element-6614">
                  <div className="text-sm font-medium text-slate-900" data-id="element-6615">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-6616">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-6617">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-6618">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-6619">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6620" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6621">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6622">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6623" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-6624">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-6625" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-6626" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-6627" />

            <div className="pt-4 border-t border-slate-100" data-id="element-6628">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6629">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6631" />} onClick={handleSave} data-id="element-6630">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-6632">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6633">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6634">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6635">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-6636" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-6637">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-6638" />
            <div className="grid grid-cols-2 gap-4" data-id="element-6639">
              <Input label="Порт" defaultValue="587" data-id="element-6640" />
              <div data-id="element-6641">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6642">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6643">
                  <option value="tls" data-id="element-6644">TLS</option>
                  <option value="ssl" data-id="element-6645">SSL</option>
                  <option value="none" data-id="element-6646">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-6647" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-6648" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astriqo.com" data-id="element-6649" />
            <Input label="Имя отправителя (From Name)" defaultValue="Astriqo" data-id="element-6650" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-6651">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6652">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6653">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-6654" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-6655">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6656">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6658" />} onClick={handleSave} data-id="element-6657">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-6659">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6660">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6661">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6662">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-6663" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-6664">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6665">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6666">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-6667" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-6668">
            <div data-id="element-6669">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6670">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-6671" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-6672">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6673">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6675" />} onClick={handleSave} data-id="element-6674">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-6676">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6677">
        <div className="flex justify-between items-center mb-4" data-id="element-6678">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-6679">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6680" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6682" />} data-id="element-6681">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-6683">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6684">
            <div className="flex justify-between items-start mb-2" data-id="element-6685">
              <div data-id="element-6686">
                <div className="text-sm font-bold text-slate-900" data-id="element-6687">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-6688">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6689">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6690">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6691">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6692">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6693">
                <Trash2 className="w-4 h-4" data-id="element-6694" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6695">
            <div className="flex justify-between items-start mb-2" data-id="element-6696">
              <div data-id="element-6697">
                <div className="text-sm font-bold text-slate-900" data-id="element-6698">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-6699">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6700">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6701">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6702">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6703">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6704">
                <Trash2 className="w-4 h-4" data-id="element-6705" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-6706">
      <div data-id="element-6707">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-6708">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-6709">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-6710" />
    </div>;
}